import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp(props) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:28</span>Introduction of the guest.</li>
                            <li><span>01:40</span>Steve’s background and History.</li>
                            <li><span>04:17</span>How to create an action plan out of a basic idea?</li>
                            <li><span>06:35</span>Importance of Purpose in building a business .</li>
                            <li><span>08:00</span>How to effectively onboard partners and investors for a business?</li>
                            <li><span>09:20</span>The fear of unknown that hinders an entrepreneur.</li>
                            <li><span>10:35</span>How do you recover from a setback and the mindset required for success?</li>
                            <li><span>13:13</span>Corporate Social Responsibility and the importance of helping communities.</li>
                            <li><span>14:17</span>Profit as a bi-product of the “why” behind your business.</li>
                            <li><span>14: 29</span> How the Veteran App helps fight against the stigma against Veterans.</li>
                            <li><span>18:55</span>The response of the veteran community (target audience) to the Veteran app.</li>
                            <li><span>23:08</span>What makes mobile applications the right medium for success for businesses?</li>
                            <li><span>24:30</span>Importance of time, resources, and strategies to drive up productivity.</li>
                            <li><span>26:01</span>Scaling a business and the spirit of entrepreneurship.</li>
                            <li><span>27:30</span>A conversation on emerging technologies – Machine Learning.</li>
                            <li><span>30:42</span>Adoption of an application by the target audience.</li>
                            <li><span>33:13</span>How to deal with negative publicity or response?</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;